import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfigService } from './api-config.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  private baseUrl = '';
  constructor(private apiConfigService: ApiConfigService) {
    this.baseUrl = this.apiConfigService.getApiUrl('');
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // --- IMPORTANT ---
    // Replace 'your_username' and 'your_password' with your actual credentials.
    const username = 'buraday';
    const password = 'R@Bu3y@2k3';

    // Only add the header for POST requests going to the proxied API or the direct API.
    if (request.method === 'POST' && (request.url.startsWith(this.baseUrl) || request.url.startsWith('/api/'))) {
      const basicAuthHeader = 'Basic ' + btoa(username + ':' + password);
      request = request.clone({
        setHeaders: {
          Authorization: basicAuthHeader
        }
      });
    }

    return next.handle(request);
  }
}
